module.exports = __webpack_public_path__ + "79499ed1da3154cbcac7f888110d00e1.ttf";